import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FormControl, ValidationErrors } from '@angular/forms';
import { map } from 'rxjs/operators';

@Injectable()
export class ValidationMessageHelperService {
  public createValidationObservable(formControl: FormControl): Observable<ValidationErrors|null> {
    return formControl.statusChanges
      .pipe(
        map(status => status === 'INVALID'),
        map(isInvalid => isInvalid ? formControl.errors : null),
      );
  }
}
